<template>
    <div class="app-wrapper">
        <NavBar />
        <section class="m_container">
            <div class="whtie_wrap">
                <div class="right_menu">
                    <RightMenu
                        :current-url="currentView"
                        @click="changeMenu"
                    />
                </div>
                <div class="left_content">
                    <component :is="currentView" />
                </div>
            </div>
        </section>
        <Footer />
    </div>
</template>

<script>
import waves from '@/directive/waves'
import NavBar from '@/components/NavBar'
import Footer from '@/components/Footer'
import RightMenu from './component/rightMenu'
import Activities from './activities/index'
import Message from './message/index'
import Profile from './user/profile'
import EditPassword from './user/editPassword'
import { getTid, setTid } from '@/utils/cookies'

export default {
    name: 'My',
    directives: { waves },
    components: { NavBar, Footer, RightMenu, Activities, Message, Profile, EditPassword },
    mixins: [],
    data() {
        return {
            tid: this.$route.query.tid ? this.$route.query.tid : getTid(),
            currentView: 'Activities'
        }
    },

    watch: {
        '$route.query': {
            handler(val) {
                const { tid = '', pkey = '' } = val
                tid ? setTid(this.tid) : getTid()
                pkey ? this.currentView = pkey : ''
            },
            immediate: true
        }
    },

    methods: {
        changeMenu(e) {
            console.log('e', e)
            this.currentView = e
        }
    }
}
</script>
<style rel="stylesheet/scss" lang="scss">
@import '../../styles/my';
</style>
